/**
 * @Author: v_jppjpeng
 * @Date: 2023-12-18 15:31:41
 * @Explain: 字母相关格式化
 */

import { LanguageEnum } from '@/definition/common/data.d';

// 下划线 -> 小驼峰
const getCamelCase = (str: string) => {
  let arr = str.split('_');
  return arr
    .map((item, index) => {
      if (index === 0) {
        return item;
      } else {
        return item.charAt(0).toUpperCase() + item.slice(1);
      }
    })
    .join('');
};

// 小驼峰 -> 下划线
const getUnderlineConcat = (str: string) =>
  str.replace(/[A-Z]/g, (match) => '_' + match.toLowerCase());

export type convertKeysToUnderscoreParamsTypes = {
  /** 被转换数据 */
  data: any;
  /**  true -> 小驼峰 -> 下划线;  false -> 下划线 -> 小驼峰*/
  switchToUnderline?: boolean;
  /** 参数无需转换的key（备注：value会被层层递归符合规则即会转换） */
  ignoreConvertedKey?: string[];
  /** 参数value对应的key需要转换，而value无需转换;（备注：ignoreConvertedValueKey优先级大于ignoreConvertedKey） */
  ignoreConvertedValueKey?: string[];
};
/**
 * 小驼峰key 与 下划线key 命名转换
 * obj：数据
 * switchToUnderline： true -> 小驼峰 -> 下划线;  false -> 下划线 -> 小驼峰
 * ignoreConvertedKey：参数无需转换的key（备注：value会被层层递归符合规则即会转换） - 默认添加LanguageEnum
 *
 */
export const convertKeysToUnderscore = (
  convertKeysToUnderscoreParams: convertKeysToUnderscoreParamsTypes,
): any => {
  let {
    data,
    switchToUnderline = true,
    ignoreConvertedKey = [],
    ignoreConvertedValueKey = [],
  } = convertKeysToUnderscoreParams;
  // 参数不做驼峰和下划线互转换的key
  ignoreConvertedKey = [...ignoreConvertedKey, ...Object.values(LanguageEnum)];

  // 非对象、null、undefind，直接返回
  if (typeof data !== 'object' || data === null) return data;

  // 数组，递归处理每个元素
  if (Array.isArray(data))
    return data.map((i) =>
      convertKeysToUnderscore({
        data: i,
        switchToUnderline,
        ignoreConvertedKey,
        ignoreConvertedValueKey,
      }),
    );

  // 对象
  const result: any = {};
  for (const key in data) {
    if (Object.hasOwnProperty.call(data, key)) {
      let convertedKey: string = '';
      // 参数value对应的key需要转换，且value也需要转换
      if (!ignoreConvertedValueKey.includes(key)) {
        // 参数key需要转换
        if (!ignoreConvertedKey.includes(key)) {
          // 重新拼接key
          convertedKey = switchToUnderline
            ? getUnderlineConcat(key)
            : getCamelCase(key);

          // 递归处理嵌套的对象
          result[convertedKey] = convertKeysToUnderscore({
            data: data[key],
            switchToUnderline,
            ignoreConvertedKey,
            ignoreConvertedValueKey,
          });
        }
        // 参数key不需要转换
        else {
          result[key] = convertKeysToUnderscore({
            data: data[key],
            switchToUnderline,
            ignoreConvertedKey,
            ignoreConvertedValueKey,
          });
        }
      }
      // 参数value对应的key需要转换，而value无需转换
      else {
        // 重新拼接key
        convertedKey = switchToUnderline
          ? getUnderlineConcat(key)
          : getCamelCase(key);

        // 递归处理嵌套的对象
        result[convertedKey] = data[key];
      }
    }
  }
  return result;
};

/**
 *
 * 按首字母排序
 */
export function compareByFirstLetter(a: any, b: any, sortKey: string) {
  const aVal = a[sortKey];
  const bVal = b[sortKey];
  // const plugInLanguage = getLocalStorage(StoreKeyEnum.DESIGN_LANGUAGE);
  // if (plugInLanguage === AbbreviationLanguageEnum.EN) {
  //   const aFirstLetter = aVal.charAt(0).toUpperCase();
  //   const bFirstLetter = bVal.charAt(0).toUpperCase();
  //   if (aFirstLetter < bFirstLetter) {
  //     return -1;
  //   }
  //   if (aFirstLetter > bFirstLetter) {
  //     return 1;
  //   }
  //   return 0;
  // } else {
  //   return aVal.localeCompare(bVal, 'zh-CN');
  // }
  return aVal && bVal ? aVal.localeCompare(bVal, 'zh-CN') : 0;
}
